module.exports = __webpack_public_path__ + "static/media/reactbeginer.5bb1731f.PNG";